<script setup>
defineProps({
  questionId: {
    type: [String, Number],
    required: true,
  },
  options: {
    type: Array,
    required: true,
  },
  selectedOption: {
    type: String,
    required: false,
  },
});

defineEmits(["change"]);
const inputModel = defineModel({ type: String });
</script>

<template>
  <div class="mt-2">
    <div class="inline-flex flex-col items-start gap-2" data-sr-mask>
      <label
        v-for="option in options"
        :key="option.value"
        :class="[
          'inline-block cursor-pointer rounded-full px-5 py-3 font-bold',
          'border border-brand-primary-teal-400 bg-white text-brand-black',
          'hover:bg-brand-primary-teal-300 hover:text-white',
          'active:bg-brand-primary-teal-400 active:text-white',
          'has-[input:checked]:bg-brand-primary-teal-400 has-[input:checked]:text-white',
          'has-[input:focus-visible]:ring-2 has-[input:focus-visible]:ring-focus-highlight-light has-[input:focus-visible]:ring-offset-2 has-[input:focus-visible]:outline-none',
        ]"
      >
        <input
          v-model="inputModel"
          class="sr-only"
          :aria-describedby="`question-label-${questionId}`"
          type="radio"
          :name="`radio-options-${questionId}`"
          :value="option.value"
          :checked="option.value === selectedOption"
          @change="$emit('change', $event)"
        />
        <span>{{ option.label }}</span>
      </label>
    </div>
  </div>
</template>
